import { useEffect, useState } from "react";
import { BrutalCard, Badge } from "../common/Brutal";
import { api } from "../../lib/api";

const CAMPSITE_IMG =
  "/campsite.jpg";

const ROUTE_IMG =
  "https://customer-assets.emergentagent.com/job_campground-command/artifacts/87yo8mpx_campsitetouptown.jpg";

const FESTIVAL_MAP_IMG =
  "https://customer-assets.emergentagent.com/job_campground-command/artifacts/yspsa24y_festivalmap.jpg";

const ZONE_TYPE_LABEL = {
  tent: "Tent Only",
  car: "Car + Tent",
  both: "Tent + Car",
};

export const LandingMap = () => {
  const [zones, setZones] = useState([]);

  useEffect(() => {
    api
      .get("/zones")
      .then((r) => setZones((r.data || []).filter((z) => z.open_for_booking)))
      .catch(() => setZones([]));
  }, []);

  return (
    <section id="map" className="max-w-7xl mx-auto px-4 py-16">
      <div className="flex items-end justify-between flex-wrap gap-4 mb-6">
        <div>
          <Badge color="magenta">KAOGMA GROUNDS</Badge>
          <h2 className="display text-4xl sm:text-5xl mt-3 text-[#3D1E6D]">
            KAOGMA GROUNDS
            <br />
            Capitol Complex
          </h2>
        </div>
        <p className="max-w-md text-[#6B4E9E]">
          Two zones, one food hub, and shower areas — all surrounding the main
          campsite at the Kaogma Grounds, Capitol Complex.
        </p>
      </div>
      <BrutalCard className="overflow-hidden p-0">
        <img
          src={CAMPSITE_IMG}
          alt="KAOGMA Grounds Campsite Map"
          className="w-full h-auto block"
          data-testid="campsite-map"
        />
      </BrutalCard>

      <div
        className="grid sm:grid-cols-2 gap-4 mt-6"
        data-testid="landing-zones-panel"
      >
        {zones.map((z, i) => {
          const available = Math.max(0, (z.capacity || 0) - (z.occupied || 0));
          return (
            <BrutalCard
              key={z.id || i}
              className="p-5"
              data-testid={`landing-zone-${z.name?.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <Badge color={i % 2 ? "magenta" : "purple"}>
                {ZONE_TYPE_LABEL[z.type] || z.type}
              </Badge>
              <div className="display text-2xl mt-2 text-[#3D1E6D]">
                {z.name}
              </div>
              {z.description && (
                <div className="text-sm text-[#6B4E9E] mt-1">
                  {z.description}
                </div>
              )}
              <div className="flex items-center gap-2 mt-3 text-xs font-bold uppercase tracking-widest">
                <span className="kf-border bg-[#FFB400] px-2 py-1 text-[#3D1E6D]">
                  Cap {z.capacity}
                </span>
                <span
                  className={`kf-border px-2 py-1 ${
                    available > 0
                      ? "bg-[#10B981] text-white"
                      : "bg-[#E5247C] text-white"
                  }`}
                >
                  {available > 0 ? `${available} Open` : "Full"}
                </span>
              </div>
            </BrutalCard>
          );
        })}
      </div>

      <div className="mt-12">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-6">
          <div>
            <Badge color="purple">GETTING THERE</Badge>
            <h3 className="display text-3xl sm:text-4xl mt-3 text-[#3D1E6D]">
              Route Map to
              <br />
              CamSur Uptown
            </h3>
          </div>
          <p className="max-w-md text-[#6B4E9E]">
            From Kaogma Grounds Campsite to CamSur Uptown — pick the Maharlika
            Highway loop or the CWC Lago Del Rey shortcut.
          </p>
        </div>
        <BrutalCard className="overflow-hidden p-0">
          <img
            src={ROUTE_IMG}
            alt="Route Map from Kaogma Grounds Campsite to CamSur Uptown"
            className="w-full h-auto block"
            data-testid="route-map-uptown"
          />
        </BrutalCard>
      </div>
      <div className="mt-12">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-6">
          <div>
            <Badge color="purple">FESTIVAL MAP</Badge>
            <h3 className="display text-3xl sm:text-4xl mt-3 text-[#3D1E6D]">
              The Official
              <br />
              KAOGMA 2026 Map
            </h3>
          </div>
          <p className="max-w-md text-[#6B4E9E]">
            Navigate your way through the ultimate celebration with the
            official Kaogma 2026 Festival Map!
          </p>
        </div>
        <BrutalCard className="overflow-hidden p-0">
          <img
            src={FESTIVAL_MAP_IMG}
            alt="Official KAOGMA 2026 Festival Map"
            className="w-full h-auto block"
            data-testid="festival-map"
          />
        </BrutalCard>
      </div>
    </section>
  );
};
